import * as React from 'react';

/**
 * If we want to BaseContentfulComponent to use preview api it needs to be wrapped in this context.
 * This context doesn't need to pass in any value. Just the fact that BaseContentfulComponent is rendered in it is enough.
 */
var ContentfulPreviewContext = React.createContext({});

export { ContentfulPreviewContext };
//# sourceMappingURL=PreviewContext.esm.js.map
